var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDatasmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.38a4.63 4.63 0 0 0-3.52 7.61l6.51-6.51A4.6 4.6 0 0 0 6 1.38ZM.62 6A5.38 5.38 0 0 1 9.8 2.2a.37.37 0 0 1 0 .53L2.73 9.8a.38.38 0 0 1-.53 0A5.36 5.36 0 0 1 .62 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27 2.2a.38.38 0 0 1 .53 0A5.36 5.36 0 0 1 6 11.38c-1.48 0-2.83-.6-3.8-1.58a.37.37 0 0 1 0-.53L9.27 2.2ZM3.01 9.52A4.63 4.63 0 0 0 9.53 3L3 9.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDatasmall);
export default __webpack_public_path__ + "static/media/noData.small.533c398e11a765f146a2db254e56ba92.svg";
export { ForwardRef as ReactComponent };